// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"_0-z"};